module.exports = __webpack_public_path__ + "img/返回.5df059f2.png";